import React from 'react'
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter 
          options={{
            strings: [
              "MERN Stack Developer",
              "Frontend Developer",
              "Backend Developer",
              "UI/UX Designer",
              "Graphical Editor"
            ],
            autoStart: true,
            loop: true,
            deleteSpeed: 50,
        
          }}
        />
  )
}

export default Type